<template>
  <div>
    <table>
      <tr>
        <th></th>
        <th v-for="day in weekdays" class="weekday">
          {{ day }}
          <!-- Get days of week -->
        </th>
      </tr>

      <template v-for="category in categories" v-if="!category.parentId">
        <!-- FIXME - Make into a component - don't duplicate! -->
        <tr :class="['categoryRow', category.children && category.showChildren ? 'hasChildren' : '']">
          <td class="categoryName">
            <category-details-block :category="category" />
          </td>
          <td v-for="day in week">
            <static-block-row
              :completed="getCategoryCompleted(category.id, day, !category.showChildren)"
              :quota="getCategoryQuota(category.id, day, !category.showChildren)"
              :color="category.color"
              size="small"
            />
          </td>
        </tr>

        <template v-for="childId in Object.keys(category.children || {})" v-if="category.showChildren">
          <tr class="categoryRow subcategoryRow">
            <td class="categoryName">
              <subcategory-details-block :categoryId="childId" />
            </td>
            <td v-for="day in week">
              <static-block-row
                :completed="
                  isToday(day) ? Object.keys(categories[childId].blocks).length : categories[childId].days[day] || 0
                "
                :quota="isActiveDay(categories[childId].activeDays, day) ? categories[childId].quota : 0"
                :color="getCategoryColor(childId)"
                size="small"
              />
            </td>
          </tr>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
import StaticBlockRow from "../components/StaticBlockRow.vue";
import CategoryDetailsBlock from "../components/CategoryDetailsBlock.vue";
import SubcategoryDetailsBlock from "../components/SubcategoryDetailsBlock.vue";

import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "daily-week-view",
  mixins: [categoryUtil.getMixin()],
  components: {
    "static-block-row": StaticBlockRow,
    "category-details-block": CategoryDetailsBlock,
    "subcategory-details-block": SubcategoryDetailsBlock,
  },
  props: {
    categories: Object,
  },
  methods: {
    // FIXME - Do something better, please!
    isToday(date) {
      return date == util.getCurrentDay();
    },
    // FIXME - Centralize this logic
    isActiveDay(activeDays = [], date) {
      return activeDays.includes(moment(date, util.dateString).format("ddd"));
    },
  },

  computed: {
    week() {
      return util.getCurrentWeek();
    },
    weekdays() {
      return this.week.map(d => moment(d, util.dateString).format("dddd"));
    },
  },
};
</script>

<style>
.subcategoryRow .blockRow {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.categoryRow.hasChildren .blockRow {
  padding-bottom: 0.125rem;
}
</style>

<style scoped>
table {
  margin-top: 1rem;
}

td {
  vertical-align: baseline;
  border-right: 1px solid #eee;
}

/*td:last-child {
    border-right: none;
}*/

th {
  /*font-weight: normal;*/
}

.categoryName {
  text-align: right;
  padding-right: 0.5rem;
}

.categoryName .categoryDetails {
  padding: 0;
}

.flexRow {
  align-items: baseline;
}

.flexRow.categorySummary {
  flex-wrap: nowrap;
}

.staticBlockRow {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// DailyWeekView.vue?7f9ea153